export default __webpack_public_path__ + "static/media/note_dexpro.88af2cad.png";